import { render, staticRenderFns } from "./UIDonutSvgMask.vue?vue&type=template&id=576f4a20"
import script from "./UIDonutSvgMask.vue?vue&type=script&lang=js"
export * from "./UIDonutSvgMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports